
import React, { useEffect } from 'react'
import '../css/logo.css';
import { useImagePath } from '../hooks/paths';


export default function Loading(props) {
    let imageUrl; 
    const path = useImagePath();

    useEffect(()=>{
      
        console.log('Loading...');

    },[]);


    if(props.image) 
            imageUrl = props.image
    else imageUrl= path + '/ic_wim.svg'; 
    
    return (
        <div className="logo">
            <img src={imageUrl} className="ic-logo" alt="logo Wikimenu" />
        </div>
    )
}
